import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GoldProdutoResponse } from '../../responses/motor-produto-gtin/gold-produto.response';

@Injectable({
  providedIn: 'root',
})
export class GoldProdutoService extends CommonService {
  // Rota [controller] -> GoldProduto
  private readonly apiUrl: string = environment.urlApiMotorProdutoGtin + 'goldProduto';

  constructor(private httpClient: HttpClient) {
    super();
  }

  /**
   * Obtém os dados consolidados (Gold) de um produto pelo GTIN.
   * Corresponde a: [HttpGet("{gtin}")]
   * @param gtin GTIN/EAN do produto
   */
  public getByGtin(gtin: string): Observable<GoldProdutoResponse> {
    const url = `${this.apiUrl}/${gtin}`;

    return this.httpClient
      .get<GoldProdutoResponse>(url, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
